import cx from 'classnames';
import React from 'react';

const MarketingPageWrapper = ({ children }: { children: React.ReactNode }) => (
  <>
    <div
      className={cx(
        'my-xxl mx-m flex',
        'flex-col items-baseline justify-center',
        'md:my-xxxl md:mx-l',
        'lg:my-xxxl lg:mx-0 lg:flex-row lg:items-start'
      )}
      data-tp-id='gen-Flex-77c5eff7-69ce-4dfb-a485-edad2c3eddbc'
    >
      {children}
    </div>
  </>
);

export default MarketingPageWrapper;
